<template>
    <div>
        <!-- STEP 1 -->
        <div class="box" id="step_1" style="z-index:1!important;">
            <!-- STEP NUMBER XL -->
            <div class="step__number__xl">
                01
            </div>
            <div class="box__header">
                <h3 class="box__title">
                    <span class="number">
                        1
                    </span>
                    Información de mi auto
                </h3>
            </div>
            <basic-info-form :err="err" :specs="specs" :numberFormat="numberFormat"
                    :editable="editable" :step="step" @next="autoSaveStep()" @eraseSpecs="eraseSpecs" @getSpecs="getVersionSpecs" @submit="submitFirstStep">
            </basic-info-form>
        </div>
        <!-- STEP 2 -->
        <div class="box" id="step_2">
            <!-- STEP NUMBER XL -->
            <div v-show="step >= 2" class="step__number__xl">
                02
            </div>
            <div class="box__header">
                <h3 class="box__title" :class=" (step <= 1) ? 'opacity-20' : '' ">
                    <span class="number">
                        2
                    </span>
                    <span>
                        Características de mi auto
                        <span class="opacity-60 tx-14 block mt-1">
                            Estan son las características de fábrica de tu modelo. Si lo deseas, elimina la selección de los features que tu auto no cumpla.
                        </span>
                    </span>
                </h3>
            </div>
            <transition name="slide-fade">
                <specsComponent v-show="step >= 2" :currentSpecs="currentSpecs" :specs="specs" :continueButton="step == 2" @next="autoSaveStep()" @specsChange="changeSpecs" class="box__body"> </specsComponent>
            </transition>
        </div>
        <!-- STEP 3 -->
        <transition name="fade">
            <div v-show="step >= 2" class="box" id="step_3">
                <!-- STEP NUMBER XL -->
                <div v-show="step > 2" class="step__number__xl">
                    03
                </div>
                <div class="box__header flex justify-content-between align-items-center">
                    <h3 class="box__title" :class=" (step <= 2) ? 'opacity-20' : '' ">
                        <span class="number">
                            3
                        </span>
                        Fotografías de mi auto
                    </h3>
                    <img width="35px" src="/assets/images/helpers/icon-land-scape.svg" alt="" :class=" (step <= 1) ? 'opacity-20' : '' ">
                </div>
                <transition name="slide-fade">
                    <div v-show="step > 2" class="box__body">
                        <hr>
                        <div v-if="componentMounted" class="pt-6 md:pt-14">
                            <div class="gs:grid">
                                <div class="md:col-8 mb-8 md:mb-0">
                                    <upload-cover @carCover="carCover = $event" @coverFile="coverFile = $event" :currentCover="editable && editable.gallery_cover ? editable.gallery_cover.image : ''"></upload-cover>
                                </div>
                                <div class="md:col-8">
                                    <upload-gallery @carGallery="carGallery = $event" @galleryFiles="galleryFiles = $event" :currentGallery="editable && editable.gallery ? editable.gallery : ''"></upload-gallery>
                                </div>
                            </div>
                        </div>
                        <!-- BTN NEXT -->
                        <div v-show="stepThree()" @click="autoSaveStep()" class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8">
                            Continuar
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <!-- STEP 4 -->
        <transition name="fade">
            <div v-show="step >= 3" class="box" id="step_4">
                <!-- STEP NUMBER XL -->
                <div v-show="step > 3" class="step__number__xl">
                    04
                </div>
                <div class="box__header flex flex-column sm:flex-row justify-content-between sm:align-items-center">
                    <h3 class="box__title" :class=" (step <= 3) ? 'opacity-20' : '' ">
                        <span class="number">
                            4
                        </span>
                        Precio
                    </h3>
                    <div class="alert alert--warning py-3 px-4 md:px-6 md:-my-3 sm:ml-10 mt-4 hidden">
                        <strong>Tu anuncio tiene un precio alto</strong> en comparación a la guía Libro Azul. <br>
                        Te recomendamos acercarte al precio sugerido.
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-show="step > 3" class="box__body">
                        <hr>
                        <div class="pt-12 md:pt-18 pb-6 md:pb-8">
                            <!-- INPUT PRICE -->
                            <div class="input__price tx-16 md:tx-40 flex justify-content-between align-items-end tx-grey-1 pb-2 mb-6 mx-a">
                                <span>
                                    $
                                </span>
                                <label for="my_price" class="bind_price cursor-text relative -mb-2 md:-mb-4">
                                    {{ formatToPrice(price) }}
                                    <money :class="err && err['price'] ? 'border-red' : ''" class="bind_price absolute t-0 l-0 w-full h-full" id="my_price" v-model="price" v-bind="numberFormat"></money>
                                </label>
                                <span>
                                    MXN
                                </span>
                            </div>
                            <!-- <p class="tx-14 sm:tx-16 tx-orange-1 weight-700 tx-center mb-0">
                                Precio sugerido $356,000 MXN
                            </p> -->
                        </div>
                        <!-- BTN NEXT -->
                        <div v-show="stepFour()" @click="autoSaveStep()" class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8">
                            Continuar
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <!-- STEP 5 -->
        <transition name="fade">
            <div v-show="step >= 4" class="box" id="step_5" style="z-index:1!important;">
                <!-- STEP NUMBER XL -->
                <div v-show="step > 4" class="step__number__xl">
                    05
                </div>
                <div class="box__header">
                    <h3 class="box__title" :class=" (step <= 4) ? 'opacity-20' : '' ">
                        <span class="number">
                            5
                        </span>
                        Ubicación de mi auto
                    </h3>
                </div>
                <transition name="slide-fade">
                    <div v-show="step > 4" class="box__body">
                        <hr>
                        <div class=" pt-8 md:pt-7">
                            <GoogleMapLoader :err="err"
                            :api="google_maps_api"
                            :countries="countries"
                            :step="step"
                            :editable="editable"
                            :states="states"
                            @ladaCellphoneChanged="assignLadaCellphone"
                            @cellphoneChanged="assignCellphone"
                            @ladaPhoneChanged="assignLadaPhone"
                            @PhoneChanged="assignPhone"
                            @addressChanged="assignAddress"
                            @stateChanged="assignState"
                            @cityChanged="assignCity"
                            @placeChanged="assignPlace"
                            @suburbChanged="assignSuburb"
                            @zipcodeChanged="assignZipcode"
                            @next="autoSaveStep()"
                            ref='maps'
                            />
                            <div v-if="user_type != 'agencia'">
                                <span class="opacity-60 tx-14 block mt-1">
                                    Por seguridad, no mostraremos la ubicación exacta de tu vehículo.
                                </span>

                                <input class="check-mod" id="share_maps" type="checkbox" checked v-model="share_maps">
                                <label class="w-fit mx-a md:mr-0" for="share_maps" >
                                    Deseo compartir el mapa en mi producto
                                    <span class="mask-check ml-2">
                                        <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <!-- STEP 6 -->
        <transition name="fade">
            <div v-show="step >= 5" class="box z-1" id="step_6">
                <!-- STEP NUMBER XL -->
                <div v-show="step > 5" class="step__number__xl">
                    06
                </div>
                <div class="box__header">
                    <h3 class="box__title" :class=" (step <= 5) ? 'opacity-20' : '' ">
                        <span class="number">
                            6
                        </span>
                        Extras
                    </h3>
                </div>
                <transition name="slide-fade">
                    <div v-show="step > 5" class="box__body relative">
                        <hr>
                        <div class="characteristics__grid pt-6 md:py-20">
                            <div class="item">
                                <input class="check-mod" id="all_services" type="checkbox" v-model="agency_services">
                                <label for="all_services">
                                    Todos los servicios de agencia
                                    <span class="mask-check">
                                        <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                                    </span>
                                </label>
                            </div>
                            <div class="item">
                                <input class="check-mod" id="sole_owner" type="checkbox" v-model="one_owner">
                                <label for="sole_owner">
                                    Único dueño
                                    <span class="mask-check">
                                        <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                                    </span>
                                </label>
                            </div><div class="item">
                                <input class="check-mod" id="original_invoice" type="checkbox" v-model="invoice">
                                <label for="original_invoice">
                                    Factura original
                                    <span class="mask-check">
                                        <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                                    </span>
                                </label>
                            </div>
                            <div class="item">
                                <input class="check-mod" id="no_accidents" type="checkbox"  v-model="sinister">
                                <label for="no_accidents">
                                    Sin siniestros
                                    <span class="mask-check">
                                        <img src="/assets/images/helpers/icon-check-white.svg" alt="">
                                    </span>
                                </label>
                            </div>
                        </div>
                        <!-- BTN NEXT -->
                        <div v-show="step == 6" @click="autoSaveStep()" class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8">
                            Continuar
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <!-- STEP 7 -->
        <transition name="fade">
            <div v-show="step >= 6" class="box" id="step_7">
                <!-- STEP NUMBER XL -->
                <div v-show="step > 6" class="step__number__xl">
                    07
                </div>
                <div class="box__header">
                    <h3 class="box__title" :class=" (step <= 6) ? 'opacity-20' : '' ">
                        <span class="number">
                            7
                        </span>
                        Descripción
                    </h3>
                </div>
                <transition name="slide-fade">
                    <div v-show="step > 6" class="box__body">
                        <hr>
                        <div class="form-group pt-6 md:pt-14">
                            <textarea required v-model="description" :class="err && err['description'] ? 'border-red' : ''" class="form-input form-input--big resize-none" name="description" id="description_input" cols="30" rows="6" placeholder="Cuentanos más sobre tu auto"></textarea>
                        </div>
                        <!-- BTN NEXT -->
                        <div v-show="stepSeven()" @click="autoSaveStep()" class="btn btn--green-ad btn--next weight-500 flex mx-a sm:mr-0 mt-8">
                            Continuar
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <!-- SUBMIT CAR -->
        <transition name="fade">
            <input @click="saveForm($event)" v-show="step == 8" class="btn btn--green-ad btn--submit-car weight-700 tx-16 flex mx-a" type="submit" value="Enviar a revisión">
        </transition>
    </div>
</template>
<script>
import GoogleMapLoader from './GoogleMapLoader.vue';
import {TheMask} from 'vue-the-mask';
import {Money} from 'v-money';
import {mapActions, mapState} from 'vuex';

import vSelect from 'vue-select';
Vue.component( 'v-select', vSelect );

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import specsComponent from './SpecsComponent.vue';
import basicInfoForm from './forms/basicInfoForm.vue';

Vue.use(VueSweetalert2);
export default {
    data: () => ({
        componentMounted: false,
        edit: null,
        editData: false,
        err: null,
        step: 0,
        carCover:[],
        coverFile:[],
        carGallery:[],
        galleryFiles:[],
        dragCount: 0,
        durationAnimatedNumber: 300,
        price: 0,
        years: [],
        brands: [],
        models: [],
        versions: [],
        states: [],
        cities: [],
        countries: [],
        conditions: [],
        year_id: '',
        brand_id: '',
        model_id: '',
        version_id: '',
        condition_id: '',
        bodyType : '',
        fuelType : '',
        horsePower : '',
        description: '',
        lat: null,
        lng: null,
        user_type: null,
        kilometers: 0,
        share_maps: null,
        agency_services: null,
        one_owner: null,
        sinister: null,
        invoice: null,
        formData: null,
        currentSpecs: null,
        edited: {
            model_id: false,
            version_id : false,
            currentSpecs : false,
        },
        numberFormat: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        specs : {},
        interior_color: '',
        exterior_color: '',
        selectedSpecs : [],
        google_maps_api: null
    }),
    props : ['editableProp'],
    watch: {
        step(value) {
            var container = this.$el.querySelector("#step_"+ value);
            if (!!container) {
                container.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
        coverFile(newValue, oldValue) {
            this.setToFormData('coverFile', newValue[0]);
        },
        galleryFiles(newValue, oldValue) {
            let vm = this;
            vm.formData.delete('galleryFiles');
            newValue.forEach(function(item, index){
                vm.setToFormData('galleryFiles[' + index +']', item);
            });
        },
        selectedSpecs(newValue, oldValue) {
            let vm = this;
            this.setToFormData('specs', JSON.stringify(newValue));
        },
        condition_id(newValue, oldValue) {
            this.setToFormData('condition_id', newValue);
        },
        interior_color(newValue, oldValue) {
            this.setToFormData('interior_color', newValue);
        },
        exterior_color(newValue, oldValue) {
            this.setToFormData('exterior_color', newValue);
        },
        bodyType(newValue, oldValue) {
            this.setToFormData('bodyType', newValue);
        },
        fuelType(newValue, oldValue) {
            this.setToFormData('fuelType', newValue);
        },
        horsePower(newValue, oldValue) {
            this.setToFormData('horsePower', newValue);
        },
        year_id(newValue, oldValue) {
            this.brand_id = "";
            this.model_id = "";
            this.version_id = "";
            this.currentSpecs = null;
            this.specs = {};
            this.setToFormData('year_id', newValue);
        },
        share_maps(newValue, oldValue) {
            this.setToFormData('share_maps', newValue);
        },
        agency_services(newValue, oldValue) {
            this.setToFormData('agency_services', newValue);
        },
        one_owner(newValue, oldValue) {
            this.setToFormData('one_owner', newValue);
        },
        sinister(newValue, oldValue) {
            this.setToFormData('sinister', newValue);
        },
        invoice(newValue, oldValue) {
            this.setToFormData('invoice', newValue);
        },
        price(newValue, oldValue) {
            this.setToFormData('price', newValue);
        },
        brand_id(newValue, oldValue) {
            let vm = this;
            this.model_id = "";
            this.version_id = "";
            this.currentSpecs = null;
            this.specs = {};
            vm.setToFormData('brand_id', newValue);
            if (oldValue != newValue ) {
                vm.models = [];
            }
            vm.getModelsAsync();
        },
        model_id(newValue, oldValue) {
            let vm = this;
            this.version_id = "";
            this.currentSpecs = null;
            this.specs = {};
            vm.setToFormData('model_id', newValue);
            if (oldValue != newValue ) {
                vm.versions = [];
            }
            vm.getVersionAsync();
        },
        version_id(newValue, oldValue) {
            let versionTitle = this.versions.find(version => version.id === newValue).title;
            this.setToFormData('version', newValue);
            this.setToFormData('version_title', versionTitle);
            if(oldValue != newValue) {
                this.getVersionSpecs(this.version_id);
            }
        },
        kilometers(newValue, oldValue) {
            this.setToFormData('kilometers', newValue);
        },
        description(newValue, oldValue) {
            this.setToFormData('description', newValue);
        },
        user(state) {
            let vm = this;
            if ( state.id !== undefined ) {
                vm.user_type    = state.type;
                this.setToFormData('user_id', state.id);
                this.setToFormData('user_type', state.type);
            }
        },
        user_type(newValue, oldValue) {
            let vm = this;
            vm.$refs.maps.user_type = newValue;
        },
        lat(newValue, oldValue) {
            let vm = this;
            this.setToFormData('lat', newValue);
        },
        lng(newValue, oldValue) {
            let vm = this;
            vm.setToFormData('lng', newValue);
        },
    },
    components: {
        GoogleMapLoader,
        TheMask,
        Money,
        specsComponent,
        'basic-info-form' : basicInfoForm,
    },
    computed: {
        ...mapState(['user']),
        ...mapState('uploader',['autoSaveJson']),
        productHasEdit() {
            return this.editable && (this.currentSpecs === null );
        },
        emptySpecs() {
            return _.isEmpty(this.specs);
        },
        editable: {
            get(){
                return this.edit;
            },
            set(value){
                this.edit = value;
            }
        }
    },
    created() {
        let vm = this;
        localStorage.removeItem('auto-save-json');
    },
    mounted() {
        let vm = this;
        vm.formData = new FormData();
        vm.init();
    },
    methods: {
        ...mapActions('uploader',['getAutoSaveJson', 'updateAutoSaveJson']),
        assignLadaCellphone(newValue) {
            this.setToFormData('lada_cellphone', newValue);
        },
        assignCellphone(newValue) {
            this.setToFormData('cellphone', newValue);
        },
        assignLadaPhone(newValue) {
            this.setToFormData('lada_phone', newValue);
        },
        assignPhone(newValue) {
            this.setToFormData('phone', newValue);
        },
        assignAddress(newValue) {
            this.setToFormData('address', newValue);
        },
        assignCity(newValue) {
            this.setToFormData('city_id', newValue);
        },
        assignPlace(newValue) {
            this.setToFormData('place_id', newValue);
        },
        assignSuburb(newValue) {
            this.setToFormData('suburb_id', newValue);
        },
        assignState(newValue) {
            this.setToFormData('state_id', newValue);
        },
        assignZipcode(newValue) {
            this.setToFormData('zip_code', newValue);
        },
        submitFirstStep(year,brand,model,version,versionTitle,condition,extColor,intColor,km,body_style,power,engine,transmission_type,fuel_type,seats)
        {
            this.setToFormData('year_id', year);
            this.setToFormData('brand_id', brand);
            this.setToFormData('model_id', model);
            this.setToFormData('version', version);
            this.setToFormData('version_title', versionTitle);
            this.setToFormData('condition_id', condition);
            this.setToFormData('exterior_color', extColor);
            this.setToFormData('interior_color', intColor);
            this.setToFormData('kilometers', km);
            this.setToFormData('body_style', body_style);
            this.setToFormData('power', power);
            this.setToFormData('engine', engine);
            this.setToFormData('transmission_type', transmission_type);
            this.setToFormData('fuel_type', fuel_type);
            this.setToFormData('seats', seats);
        },
        async init(){
            let vm = this;
            try {
                let {data} = await axios.get('/client/modules/upload_car');
                vm.years        = data.years;
                vm.brands       = data.brands;
                vm.states       = data.states;
                vm.countries    = data.countries;
                vm.conditions   = data.conditions;
                vm.google_maps_api = data.google_maps;
                vm.$store.dispatch('catalog/getProductColors');
            } catch (error) {
                console.error(error);
            }
            vm.agency_services = false;
            vm.share_maps   = true;
            vm.one_owner    = false;
            vm.sinister     = false;
            vm.invoice      = false;
            if ( !vm.editableProp ) {
                this.autoSaveStep( true );
                if (!!vm.autoSaveJson && vm.autoSaveJson.user_id){
                    vm.editable = vm.autoSaveJson;
                    vm.populateEditCar(vm.editable);
                }
            }
            if(vm.editableProp) {
                vm.editable = vm.editableProp;
                vm.populateEditCar(vm.editable);
            }
            vm.componentMounted = true;
        },
        populateEditCar(currentProduct) {
            this.price = currentProduct.price == 'NaN' || currentProduct.price == undefined ? 0 : parseInt(currentProduct.price);
            this.agency_services = !!currentProduct.agency_services && currentProduct.agency_services.toString() == 'true';
            this.invoice = !!currentProduct.invoice && currentProduct.invoice.toString() == 'true';
            this.sinister = !!currentProduct.sinister && currentProduct.sinister.toString() == 'true';
            this.one_owner = !!currentProduct.one_owner && currentProduct.one_owner.toString() == 'true';
            this.description = currentProduct.description == 'undefined' ? '' :  currentProduct.description;
            this.step = currentProduct.step ? currentProduct.step : 8;
        },
        formatToPrice(price) {
            let val = (price/1).toFixed(0).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        async getVersionSpecs(versionId) {
            try {
                let { data } = await axios.get('/client/version/' + versionId + '/specs');
                this.specs = data;
                if(this.productHasEdit  && !this.edited.currentSpecs) {
                    this.currentSpecs = JSON.parse(this.editable.specs.specs);
                    this.edited.currentSpecs = true;
                }
                    if(this.specs[8702]) {
                        this.fuelType = this.specs[8702].value;
                    }
                    if(this.specs[606]) {
                        this.bodyType = this.specs[606].value;
                    }
                    if(this.specs[15304]) {
                        this.horsePower = this.specs[15304].value;
                    }
            } catch (error) {
                console.error(error);
            }
        },
        eraseSpecs() {
            this.specs = {};
            this.fuelType = '';
            this.bodyType = '';
            this.horsePower = '';
        },
        setToFormData(target, value){
            let vm = this;
            vm.formData.set(target, value);
        },
        async saveForm(event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                return;
            };
            let vm = this;
            vm.err = null;
            if (!vm.formData.get('coverFile') || vm.formData.get('coverFile') == 'undefined') {
                vm.$swal({
                    title: "Error",
                    text: "No se ha subido una portada para tu anuncio",
                    icon: "warning",
                    showCancelButton: false,
                    showConfirmButton: true,
                    closeOnConfirm: true
                });
                return;
            }
            if (!vm.formData.get('galleryFiles[0]') || vm.formData.get('galleryFiles[0]') == 'undefined') {
                vm.$swal({
                    title: "Error",
                    text: "Debes subir al menos una imagen a la galería",
                    icon: "warning",
                    showCancelButton: false,
                    showConfirmButton: true,
                    closeOnConfirm: true
                });
                return;
            }

            vm.$swal({
                title: "Guardando...",
                text: "Espere mientras se procesa su registro de auto",
                icon: "info",
                showCancelButton: false,
                showConfirmButton: false,
                closeOnConfirm: true
            });
            if(!vm.editableProp) {
                vm.postCreateProduct();
                return;
            }
            vm.postUploadProduct();
        },
        async postUploadProduct() {
            let vm = this;
            try {
                let {data} = await axios.post(`/client/products/${vm.editable.id}/update`, vm.formData)
                .then(response => {
                    vm.product = response.data;
                    vm.$swal({
                        icon: "success",
                        title: "Carga completada",
                        text: "Su producto ahora se encuentra en revisión",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    }).then((result) => {
                        if(result){
                            window.location.href = `/mis-anuncios/${vm.product.id}`;
                        }
                    });
                }).catch(error => {
                    vm.err = error.response.data.errors;
                });
            } catch (error) {
                if( vm.err ) {
                    vm.$swal({
                        icon: 'error',
                        title: 'Error',
                        text: 'Se encontraron algunos errores en el formulario',
                    });
                }
            }
        },
        async postCreateProduct() {
            let vm = this;
            try {
                let {data} = await axios.post('/client/products', vm.formData)
                .then(response => {
                    vm.product = response.data;
                    vm.$swal({
                        icon: "success",
                        title: "Carga completada",
                        text: "Su producto ahora se encuentra en revisión",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    }).then((result) => {
                        if(result){
                            this.autoSaveStep();
                            window.location.href = `/mis-anuncios/${vm.product.id}`;
                        }
                    });
                }).catch(error => {
                    vm.err = error.response.data.errors;
                });

            } catch (error) {
                if( vm.err ) {
                    vm.$swal({
                        icon: 'error',
                        title: 'Error',
                        text: 'Se encontraron algunos errores en el formulario',
                    });
                }
            }
        },
        getBrands() {
            let vm = this;
            var data = [];

            $.each(vm.brands, function(key, brand) {
                data.push({
                    brand: brand.title,
                    value: brand.id
                });
            });
            return data;
        },
        getModels() {
            let vm = this;
            var data = [];

            $.each(vm.models, function(key, model) {
                data.push({
                    model: model.title,
                    value: model.id
                });
            });
            return data;
        },
        getVersions() {
            let vm = this;
            var data = [];

            $.each(vm.versions, function(key, version) {
                data.push({
                    version: version.title,
                    value: version.id
                });
            });
            return data;
        },
        getCondition() {
            let vm = this;
            var data = [];

            $.each(vm.conditions, function(key, condition) {
                data.push({
                    condition: condition.title,
                    value: condition.id
                });
            });
            return data;
        },
        changeSpecs(childSelectedSpecs) {
            this.selectedSpecs = childSelectedSpecs;
        },
        stepThree() {
            let vm = this;
            let show = vm.step == 3;
            show = !!show && vm.galleryFiles.length > 0;
            show = !!show && vm.coverFile.length > 0;

            return show;
        },
        stepFour() {
            let vm = this;
            let show = vm.step == 4;
            show = !!show && vm.price > 0;

            return show;
        },
        stepSeven() {
            let vm = this;
            let show = vm.step == 7;
            show = !!show && !!vm.description;

            return show;
        },
        autoSaveStep(loaded = false) {

            this.step += 1;
            var object = {};
            object['step']      = this.step;
            object['user_id']   = this.user.id;
            this.getAutoSaveJson();
            if (this.autoSaveJson.id) {
                object['id'] = this.autoSaveJson.id;
            }

            this.formData.forEach(function(value, key) {
                object[key] = value;
            });
            if ( !loaded ) {
                localStorage.setItem('auto-save-json', JSON.stringify(object) );
            }
            this.updateAutoSaveJson();
        }
    }
}
</script>
<style lang="scss">

    .border-red {
        border-color: red !important;
    }

    .vs--searchable .vs__dropdown-toggle {
        border: none;
        width: 100%;
    }

    .form-input--v-select{
        padding: 0;

        .vs__dropdown-toggle{
            padding: 0 8px;
        }
    }

    .vs__selected-options{
        flex-basis: 0;
    }

    .input-filled{
        background-color: #fafafa;
        border-color: #42ec81;
        color: #3e3f42;
    }

</style>
